class ProductCardTooltip extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const trigger = this.querySelector('svg');
    const tooltipText = this.querySelector('.ne-product-card-disclosure-text');

    if (trigger && tooltipText) {
      trigger.addEventListener('mouseenter', () => this.showTooltip(tooltipText));
      trigger.addEventListener('mouseleave', () => this.hideTooltip(tooltipText));

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleTooltip(tooltipText);
      });
    }

    document.addEventListener('click', (e) => {
      if (!e.target.closest('product-card-tooltip')) {
        this.hideAllTooltips();
      }
    });
  }

  showTooltip(tooltipText) {
    this.hideAllTooltips();
    this.positionTooltip(tooltipText);

    tooltipText.style.opacity = '1';
    tooltipText.style.visibility = 'visible';
    tooltipText.style.pointerEvents = 'auto';
  }

  hideTooltip(tooltipText) {
    tooltipText.style.opacity = '0';
    tooltipText.style.visibility = 'hidden';
    tooltipText.style.pointerEvents = 'none';
  }

  toggleTooltip(tooltipText) {
    const isVisible = tooltipText.style.opacity === '1';
    if (isVisible) {
      this.hideTooltip(tooltipText);
    } else {
      this.showTooltip(tooltipText);
    }
  }

  hideAllTooltips() {
    const allTooltips = document.querySelectorAll('product-card-tooltip');
    allTooltips.forEach(tooltip => {
      const tooltipText = tooltip.querySelector('.ne-product-card-disclosure-text');
      if (tooltipText) {
        this.hideTooltip(tooltipText);
      }
    });
  }

  positionTooltip(tooltipText) {
    const trigger = this;
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltipText.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const isMobile = viewportWidth < 768;

    const tooltipWidth = tooltipRect.width || (isMobile ? 200 : 278);

    const triggerCenter = triggerRect.left + (triggerRect.width / 2);
    let leftPosition = triggerCenter - (tooltipWidth / 2);

    const padding = 24;
    if (leftPosition < padding) {
      leftPosition = padding;
    } else if (leftPosition + tooltipWidth > viewportWidth - padding) {
      leftPosition = viewportWidth - tooltipWidth - padding;
    }

    const relativeLeft = leftPosition - triggerRect.left;

    tooltipText.style.left = `${relativeLeft}px`;
    tooltipText.style.transform = 'none';
  }
}

if (customElements.get('product-card-tooltip') === undefined) {
  customElements.define('product-card-tooltip', ProductCardTooltip);
}